import Axios from "axios";

const getVersion = ()=>{
  Axios.get(`/data/version.json?t_${new Date().getTime()}`).then(res=>{
    if(res.data){
      let version = res.data.version
      let localVersion = localStorage.getItem('version')
      if(localVersion && version !== localVersion){
        localStorage.setItem('version',version)
        window.location.reload()
      }else {
        localStorage.setItem('version',version)
      }
    }
  })
}

export default getVersion
